import React from "react";
import { Box, Typography } from "@mui/material";
import { TOKENS } from "./tokens";

/**
 * Outlined surface with an optional header (title + description + action slot).
 */
const SectionCard = ({ title, description, action, children }) => {
  const hasHeader = title || description || action;
  return (
    <Box
      sx={{
        border: `1px solid ${TOKENS.border}`,
        borderRadius: `${TOKENS.radiusM}px`,
        background: TOKENS.bgSurface,
        boxShadow: TOKENS.shadowXs,
        overflow: "hidden",
      }}
    >
      {hasHeader ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            p: "18px",
            borderBottom: children ? `1px solid ${TOKENS.borderSubtle}` : "none",
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {title ? (
              <Typography
                sx={{ fontSize: 14.5, fontWeight: 600, color: TOKENS.fg1 }}
              >
                {title}
              </Typography>
            ) : null}
            {description ? (
              <Typography sx={{ fontSize: 12.5, color: TOKENS.fg2, mt: 0.25 }}>
                {description}
              </Typography>
            ) : null}
          </Box>
          {action ? <Box sx={{ ml: "auto" }}>{action}</Box> : null}
        </Box>
      ) : null}
      {children ? <Box sx={{ p: "18px" }}>{children}</Box> : null}
    </Box>
  );
};

/**
 * 11px uppercase overline + slot — used inside DetailDrawer bodies.
 */
export const Section = ({ label, children }) => (
  <Box sx={{ mb: 2 }}>
    {label ? (
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          color: TOKENS.fg3,
          mb: 0.75,
        }}
      >
        {label}
      </Typography>
    ) : null}
    <Box>{children}</Box>
  </Box>
);

export default SectionCard;
